import React, { Component } from "react";
import { Translate, I18n } from "react-redux-i18n";
import LoadingIndicator from "../../components/LoadingIndicator";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import { userHasCommitment, isAgreementLoading, userWhoSignedCommitment } from "../../store/commitment/selectors";
import { signAgreement } from "../../store/commitment/operations";
import { loggedInUserGuid } from "../../store/iam/selectors";
import { fetchCircle } from "../../store/my_circles/operations";
import { fetchAgreements } from "../../store/circle_agreement/operations";
import { getAgreement, isLoadingAgreements } from "../../store/circle_agreement/selectors";
import { getCircleWithId } from "../../store/my_circles/selectors";
import { Converter } from "react-showdown";
import { getUserWithId } from "../../store/users/selectors";

import { Button } from "@blueprintjs/core";

class Agreement extends Component {
  mdConverter = new Converter();

  componentDidMount() {
    this.props.fetchAgreements();
  }

  signAgreement = () => {
    this.props.signAgreement(this.props.circleId).then(() => {
      this.props.fetchCircle(this.props.circleId, true);
    });
  };

  getUsesNames = () => {
    const user_names = this.props.commitment_signed_by.map(user => getUserWithId(this.props.state, user).f_name);
    user_names.join(` ${I18n.t('agreement.and')} `);
  };

  render() {
    return (
      <>
        <div className="copy-wrapper">
          {this.props.loading && <LoadingIndicator />}
          {this.props.agreement && !this.props.loading && this.mdConverter.convert(this.props.agreement)}
        </div>
        <div className="sign-agreement grid-view half">
          <div className="grid-item">
            {this.props.agreement_loading && <LoadingIndicator />}
            {!this.props.agreement_loading && (
              <Button
                disabled={this.props.has_commitment || this.props.circle.status === "member_gathering"}
                intent="primary"
                fill={true}
                onClick={this.signAgreement}>
                <Translate value="circle_admin.sign" />
              </Button>
            )}
          </div>           
        </div>
      </>
    );
  }
}

const mapStateToProps = (state, props) => ({
  state: state,
  commitment_signed_by: userWhoSignedCommitment(state, props.circleId, loggedInUserGuid(state)),
  loading: isLoadingAgreements(state),
  agreement: getAgreement(state),
  circle: getCircleWithId(state, props.circleId),
  has_commitment: userHasCommitment(state, props.circleId, loggedInUserGuid(state)),
  agreement_loading: isAgreementLoading(state)
});

const mapDispatchToProps = dispatch => ({
  fetchCircle: (id, is_updating) => dispatch(fetchCircle(id, is_updating)),
  fetchAgreements: _ => dispatch(fetchAgreements()),
  signAgreement: circleId => {
    return dispatch(signAgreement(circleId));
  },
  navigate: to => dispatch(navigate(to))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Agreement);
